import { render, staticRenderFns } from "./role-new.vue?vue&type=template&id=4205fcee&scoped=true&"
import script from "./role-new.vue?vue&type=script&lang=js&"
export * from "./role-new.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4205fcee",
  null
  
)

export default component.exports